/* eslint-disable eqeqeq */
import {connect} from "react-redux";
import { handleColorButtonChange } from "../../redux/actions/actions.js";

const Profile_Customize_ColorBtn_Button = (props) => {
    const handleClick =  (color) => {
        props.onColorButtonChange(color,props.user.id);
    }
    return (props.color == props.color_button) ?
        (
            <div value={props.color} onClick={()=>handleClick(props.color)} className={`profile_customize_section_color_button profile_customize_section_color_button_${props.color}`}>
                <i className="fa-solid fa-check profile_customize_section_color_button_tick"></i>
            </div>
        ):
        (
            <div value={props.color} onClick={()=>handleClick(props.color)} className={`profile_customize_section_color_button profile_customize_section_color_button_${props.color}`}></div>
        )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onColorButtonChange: (color,i) => dispatch(handleColorButtonChange(color,i))  
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_Customize_ColorBtn_Button);